<template>
    <div v-for="instance in instances"
         :key="instance.key"
         class="form-group"
         :class="{'has-error': instance.error}">
        <label class="control-label">
            {{ instance.field.name }}
            <span v-if="instance.field.required"
                  class="required-label">{{ l('REQUIRED') }}</span>
        </label>

        <FieldInstanceInput :instance="instance" />

        <p v-if="instance.error"
           class="help-block field-error">
            {{ l(instance.error) }}
        </p>
    </div>
</template>

<script>
import FieldInstanceInput from '@/vue/components/CustomFields/FieldInstanceInput';

export default {
    components: { FieldInstanceInput },

    props: {
        /**
         * @type {FieldInstance[]}
         */
        instances: {
            type: Array,
            required: true,
        },

        /**
         * 'edit', 'hidden', or 'view'
         */
        mode: {
            type: String,
            required: true,
        },
    },
};
</script>
